export const TYPES = {
  TOGGLE_NOTIFICATION: 'TOGGLE_NOTIFICATION',
};

export const toggleNotification = notification => ({ type: TYPES.TOGGLE_NOTIFICATION, notification });



/** WEBPACK FOOTER **
 ** ./src/redux/actions/notificationsActions.js
 **/